export const removeSearchParam = (searchParams: URLSearchParams, key: string): URLSearchParams => {
    const nextParams = new URLSearchParams(searchParams);
    nextParams.delete(key);
    return nextParams;
};

export const removeSearchParams = (searchParams: URLSearchParams, keys: string[]): URLSearchParams => {
    const nextParams = new URLSearchParams(searchParams);
    keys.forEach((key) => {
        nextParams.delete(key);
    });
    return nextParams;
};
